import { render, staticRenderFns } from "./BlockPriceCategoryIndex.vue?vue&type=template&id=eb239836&scoped=true"
import script from "./BlockPriceCategoryIndex.vue?vue&type=script&lang=js"
export * from "./BlockPriceCategoryIndex.vue?vue&type=script&lang=js"
import style0 from "./BlockPriceCategoryIndex.vue?vue&type=style&index=0&id=eb239836&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb239836",
  null
  
)

export default component.exports